@if (visibleFlows().length > 0) {
<div class="bpm-diagram-scroll">
    <div class="bpm-diagram-track bpm-diagram-track--compact">
        @for (flow of visibleFlows(); track flow.stepSequence; let i = $index) {
            <div class="bpm-step">
                <div class="bpm-pill"
                    [class.is-incomplete]="!flow.statusUuid && !flow.statusId"
                    [class.has-token]="flow.allowsToken && !isTerminalStep(i)"
                    [class.is-final]="isTerminalStep(i)">
                    <span class="bpm-pill-ord">{{ i + 1 }}</span>
                    <div class="bpm-pill-body">
                        <div class="bpm-pill-title">{{ statusName(flow.statusUuid ?? flow.statusId, flow) }}</div>
                        <div class="bpm-pill-meta">
                            @if (isTerminalStep(i)) {
                                <span class="bpm-pill-role" title="Cierre del flujo: nadie aprueba aquí">
                                    <i class="fas fa-flag-checkered" aria-hidden="true"></i>
                                    Final
                                </span>
                                @if (flow.notifyRole && flow.requiredRole) {
                                    <i class="fas fa-bell text-success" [title]="'Avisa a ' + roleLabel(flow.requiredRole)"></i>
                                }
                            } @else {
                                <span class="bpm-pill-role" [title]="roleLabel(flow.requiredRole)">
                                    <i class="fas fa-user-shield" aria-hidden="true"></i>
                                    {{ roleLabel(flow.requiredRole) }}
                                </span>
                                @if (isExtraordinaryActive(flow)) {
                                    <span class="bpm-pill-role" [title]="'Habilitación extraordinaria hasta ' + flow.alternateRoleUntil">
                                        <i class="fas fa-user-clock" aria-hidden="true"></i>
                                        {{ roleLabel(flow.alternateRole) }}
                                    </span>
                                }
                                @if (flow.notifyRole && flow.requiredRole) {
                                    <i class="fas fa-bell text-success" title="Notifica al rol"></i>
                                }
                                @if (flow.allowsToken) {
                                    <i class="fas fa-link text-primary" title="Enlace público por correo"></i>
                                }
                                @if (flow.contentReviewRole) {
                                    <i class="fas fa-images text-info"
                                        [title]="'Rol revisor: ' + roleLabel(flow.contentReviewRole)"></i>
                                }
                                @if (flow.requiresDocument) {
                                    <i class="fas fa-file-signature text-warning"
                                        [title]="'Exige documento: ' + documentTypeName(flow)"></i>
                                }
                            }
                        </div>
                    </div>
                </div>

                @if (!isLastStep(i)) {
                    <div class="bpm-arrow" aria-hidden="true">
                        <i class="fas fa-chevron-right"></i>
                    </div>
                }
            </div>
        }
    </div>
</div>
}
